import { AnnaError } from "@anna-money/anna-web-lib/utils";
import { makeAutoObservable } from "mobx";
import { type CountryClient } from "./countryClient";

const OPTIONAL_DATA_TIMEOUT = 10000;

export class CountryStore {
  private _countryList: string[] = [];

  constructor(private readonly _countryClient: CountryClient) {
    makeAutoObservable(this);
  }

  get countries(): string[] {
    return this._countryList;
  }

  private set countries(value: string[]) {
    this._countryList = value;
  }

  async init(): Promise<void> {
    this.countries = [];

    try {
      this.countries = await this._countryClient.getCountryList(OPTIONAL_DATA_TIMEOUT);
    } catch (e) {
      console.error(new AnnaError("Couldn't load country list", { cause: e }));

      this.countries = [];
    }
  }
}
